import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: true,
        config: {
            baseUrlApi: process.env.VUE_APP_BASE_URL,
            // Cards visíveis na home (parametros_sistema: pre_matricula.menus_home).
            menus: {}
        },
        menusCarregados: false
    },
    actions: {

    },
    mutations: {
        setMenus(state, menus) {
            state.config.menus = menus || {};
            state.menusCarregados = true;
        }
    },
    getters: {
        // Visibilidade de um card da home. Enquanto não carregou, nada é exibido
        // (evita mostrar um card que deveria estar oculto). Após carregar, respeita a config.
        menuVisivel: state => key => state.menusCarregados && state.config.menus[key] !== false
    }
})